import React from "react";
import "swiper/dist/css/swiper.min.css";
import "../../pages/index.styl";
class Help extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        header: props.header
    };  
  }
  
  showLoginHelpHeader = () => {
    if(this.state.header==="show") {
      return(<h2>Login Help</h2>);
    } 
  }

  render() {
    return (
      <main id="content">
        <div className="c-news" style={{    
            paddingTop: 30,          
            paddingBottom: 30,
            paddingLeft: 30,
            paddingRight: 30,
            maxWidth: 850,
            marginRight: "auto",
            marginLeft: "auto"}}>
          {this.showLoginHelpHeader()}
          <article className="c-news__article">
              <h4>
                I keep getting an error message saying 'Your username or
                password was not found in the system.'
              </h4>
              <p className="header-form__label">
                Click on 'username' or 'password' within the 'Forgot my username
                or password' located below the Password field.{" "}
              </p>
          </article>
          <article className="c-news__article">
              <h4>
                I keep getting a message saying 'Passwords are case sensitive.
                Check for capital letters.'
              </h4>
              <p className="header-form__label">
                Be sure to enter your password with the correct capitalization
                (for example; Apple vs. apple is treated differently). Click
                'password' within the 'Forgot your username or password' if you
                do not remember the correct capitalization.{" "}
              </p>
          </article>
          <article className="c-news__article">
              <h4>
                I received more than one username when I used 'Forgot your
                username or password.' How do I know which one to use?{" "}
              </h4>
              <p className="header-form__label">
                Your account does not have a unique email address. Please
                contact your administrator for the correct username information.
                (We strongly recommend that each account have its own email
                address)
              </p>
          </article>
          <article className="c-news__article">
              <h4>Is there a limit to how many times I can reset my password?</h4>
              <p className="header-form__label">
                No. You can reset your password as many times as you would like.
              </p>
          </article>
          <article className="c-news__article">
              <h4>
                When I log in I get a screen telling me that my username does
                not meet the systems requirements. What do I do?
              </h4>
              <p className="header-form__label">
                For security purposes, all usernames must conform to our new
                login requirements (at least 6 characters long and cannot be all
                numbers). When prompted to update your username; enter a new
                username in the 2 fields on the update form. (Remember: you will
                use your updated username the next time you login){" "}
              </p>
          </article>
          <article className="c-news__article">
              <h4>
                Why do the messages keep changing when the system doesn't
                recognize my username or password?
              </h4>
              <p className="header-form__label">
                Try using the 'Forgot your username or password' option. If you
                do not have success recovering your username or password please
                contact your administrator and ATI will help restore your
                account. (Remember: make note of any changes you make to your
                account since a change can affect your ability to login
                successfully){" "}
              </p>
          </article>
        </div>
      </main>
    );
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/components/Auth/Help.js